module.exports = __webpack_public_path__ + "static/media/Mac.4c11c647.svg";